import { render, staticRenderFns } from "./LoadingPhoto.vue?vue&type=template&id=965d3660&"
import script from "./LoadingPhoto.vue?vue&type=script&lang=js&"
export * from "./LoadingPhoto.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports